import { render, staticRenderFns } from "./NetworkNotification.vue?vue&type=template&id=675acb51&scoped=true&"
import script from "./NetworkNotification.vue?vue&type=script&lang=js&"
export * from "./NetworkNotification.vue?vue&type=script&lang=js&"
import style0 from "./NetworkNotification.vue?vue&type=style&index=0&id=675acb51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675acb51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675acb51')) {
      api.createRecord('675acb51', component.options)
    } else {
      api.reload('675acb51', component.options)
    }
    module.hot.accept("./NetworkNotification.vue?vue&type=template&id=675acb51&scoped=true&", function () {
      api.rerender('675acb51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/NetworkNotification.vue"
export default component.exports